import React from 'react';
// import logo from './logo.svg';
// import APP_CONST from './const/app-const';
import ADMIN_CONST from './const/admin-const';
import { ThemeProvider } from './core/context/ThemeContext';

import { Provider as ReduxProvider } from 'react-redux';
import STORE from './store';

// Assuming AppRouter is still needed, but the instruction removed its import.
// If AppRouter is no longer needed, then the content of App function would also change.
// Given the instruction "wrap AppRouter with it", AppRouter must still exist.
// I will re-add AppRouter import to maintain a syntactically correct and functional file,
// as the instruction only provided a partial import list and implied AppRouter's continued use.
import AppRouter from './AppRouter';

function App() {

  return (
    <ReduxProvider store={STORE}>
      <ThemeProvider>
        <AppRouter />
      </ThemeProvider>
    </ReduxProvider>

  );
  // return (
  //   <div className="App">
  //     <header className="App-header">
  //       <img src={logo} className="App-logo" alt="logo" />
  //       <p>
  //         Edit <code>src/App.tsx</code> and save to reload.
  //       </p>
  //       <a
  //         className="App-link"
  //         href="https://reactjs.org"
  //         target="_blank"
  //         rel="noopener noreferrer"
  //       >
  //         Learn React
  //       </a>
  //     </header>
  //   </div>
  // );
}

export default App;
